import React from "react";

function HomeLocations() {
  return (
    <section className="contact-con position-relative hmlocations">
      <div className="container-fluid">

        {/* Heading */}
        <div className="row">
          <div className="col-12">
            <div className="contact_content text-center">
              <h2>
                Our <span>Locations</span>
              </h2>
              <p>
                Visit us at any of our premium locations
              </p>
            </div>
          </div>
        </div>

        {/* Locations Row */}
        <div className="row">

          {/* Location 1 */}
          <div className="col-xl-4 col-lg-6 col-md-6 col-12 hme">
            <div className="contact-box h-100 test">
              <figure className="icon">
                <img
                  src="./assets/images/contact-icon1.png"
                  alt="location"
                  className="img-fluid"
                />
              </figure>

              <div className="content text-start">
                <h6>Jubilee HillS</h6>
                <a
                  href="https://maps.app.goo.gl/rfo7DosRqHxZPBhE7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-size-16 mb-0"
                >
                  Mohans Plaza, 733, <br />
                        Next To Madhapur Metro Station, Road No. 36, 
                        Jubilee Hills, Hyderabad, Telangana - 500033
                </a>
              </div>
            </div>
          </div>

          {/* Location 2 */}
          <div className="col-xl-4 col-lg-6 col-md-6 col-12 hme">
            <div className="contact-box h-100 test">
              <figure className="icon">
                <img
                  src="./assets/images/contact-icon1.png"
                  alt="location"
                  className="img-fluid"
                />
              </figure>

              <div className="content text-start">
                <h6>Jubilee HillS</h6>
                <a
                  href="https://maps.app.goo.gl/oxRqKNJ8Ls29Lbaz7?g_st=aw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-size-16 mb-0"
                >
                  Plot No 1354, <br />Opposite KBR Park <br />Gate No. 5, Road No 1 & 68, Jubileehills-500033
                </a>
              </div>
            </div>
          </div>

          {/* Location 3 */}
          <div className="col-xl-4 col-lg-6 col-md-6 col-12 hme">
            <div className="contact-box h-100 test">
              <figure className="icon">
                <img
                  src="./assets/images/contact-icon1.png"
                  alt="location"
                  className="img-fluid"
                />
              </figure>

              <div className="content text-start">
                <h6>Vijayawada</h6>
                <a
                  href="https://maps.app.goo.gl/RUM83bDSkGFs7M5e6?g_st=iw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-size-16 mb-0"
                >
                  Festivo, GM49+R3P, <br />Rd Number 7, Bharathi Nagar, 
                Vijayawada, Andhra Pradesh - 520008
                </a>
              </div>
            </div>
          </div>

          {/* Location 4 */}
          {/* <div className="col-xl-3 col-lg-6 col-md-6 col-12 hme">
            <div className="contact-box h-100 test">
              <figure className="icon">
                <img
                  src="./assets/images/contact-icon1.png"
                  alt="location"
                  className="img-fluid"
                />
              </figure>

              <div className="content text-start">
                <h6>Gachibowli</h6>
                <a
                  href="https://maps.app.goo.gl/dHWXTSj64sYTegaC7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-size-16 mb-0"
                >
                  Ground Floor, Plot No: 23,24, Lumbini Avenue, Gachibowli, Hyderabad, Telangana 500032
                </a>
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </section>
  );
}

export default HomeLocations;